import { render, staticRenderFns } from "./TitleWithIconEl.vue?vue&type=template&id=98294c02&scoped=true&"
import script from "./TitleWithIconEl.vue?vue&type=script&lang=ts&"
export * from "./TitleWithIconEl.vue?vue&type=script&lang=ts&"
import style0 from "./TitleWithIconEl.vue?vue&type=style&index=0&id=98294c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98294c02",
  null
  
)

export default component.exports